import { useState, type FormEvent } from "react";
import { post } from "../api";
import { safeStudentReturn } from "../passkeys";
import { Notice, StudentShell } from "../components/Layout";
import { useI18n } from "../i18n";

function fragmentToken() {
  const token = new URLSearchParams(window.location.hash.slice(1)).get("token") || "";
  if (token) history.replaceState(null, "", window.location.pathname);
  return token;
}

export function RebindPage() {
  const { t } = useI18n();
  const [token] = useState(fragmentToken);
  const [error, setError] = useState("");
  const [working, setWorking] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setWorking(true);
    setError("");
    try {
      const result = await post<{ returnTo?: string }>("/api/student/rebind", { token });
      window.location.replace(safeStudentReturn(result.returnTo));
    } catch {
      setError(t("error"));
    } finally {
      setWorking(false);
    }
  }

  return <StudentShell title={t("rebindTitle")}><section className="student-card">
    {!token && <Notice kind="error">{t("recoveryMissing")}</Notice>}
    {error && <Notice kind="error">{error}</Notice>}
    <p>{t("rebindHelp")}</p>
    <form className="stack-form" onSubmit={submit}>
      <button className="primary-button" disabled={!token || working}>{working ? t("loading") : t("rebind")}</button>
    </form>
  </section></StudentShell>;
}
